import { Routes } from '@angular/router';

import { BodyComponent } from "./body/body.component";
import { NotFoundComponent } from "./body/components/not-found/not-found.component";

export const routes: Routes = [
  {path: "", component: BodyComponent},
  {path: "**", component: NotFoundComponent}
];
